import Note from './Note.view';

export default Note;
